import React from "react";
import PropTypes from "prop-types";
import TextInfo from "@/bit/components/components.text";
import IconGlyph from "@/bit/components/components.icon-glyph";
import Label from "@/bit/components/components.cms-block.cms-label";
import { getLayoutClassName } from "./utils";

function Characteristic(props) {
  const {
    "cms-atom-text-1": title,
    "cms-atom-text-2": description,
    "cms-atom-icon-1": icon,
    "cms-atom-label-1": label,
    layout,
    cmsHandler,
    alias,
    blockName,
    index,
    frontalListToDelete,
    CmsEditableGroupIcons,
    listIndex = 1,
    className = "",
  } = props;
  const showItem = props.checked;

  const finalClassName = [
    getLayoutClassName(layout, "characteristics-item"),
    className,
    showItem === null && "skeleton",
    showItem === false && "hidden",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={finalClassName}>
      {/* Bolitas de edicion aqui */}
      {CmsEditableGroupIcons && (
        <CmsEditableGroupIcons
          noCustomLink
          elementProps={{
            ...props,
            editName: "cms-block.cms-characteristic-item",
          }}
          deleteProps={{
            index,
            itemIdDotNotation: `${blockName}${
              blockName.includes("product-info")
                ? `.cms-ml-characteristics-${listIndex}`
                : ""
            }.cms-ml-single-characteristic-list`,
            alias,
            frontalListToDelete,
          }}
          visibleTools={{
            hiring: false,
            edit: false,
            deleteItem: true,
          }}
          cmsHandler={cmsHandler}
        />
      )}
      <div className="characteristics-item-icon">
        <IconGlyph {...icon} cmsHandler={cmsHandler} />
      </div>
      <div className="characteristics-item-content">
        <div className="characteristics-item-title">
          <Label {...label} cmsHandler={cmsHandler} />
          <TextInfo {...title} cmsHandler={cmsHandler} />
        </div>
        <div className="characteristics-item-text">
          <TextInfo {...description} cmsHandler={cmsHandler} />
        </div>
      </div>
      <style jsx>{`.characteristics-item {
  position: relative;
  display: flex;
  gap: 0.5rem;
  &-grid {
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: center;
    .characteristics-item-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex-grow: 1;
    }
    .characteristics-item-title {
      min-height: 3em; 
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  &-default  {
    .characteristics-item-icon {
      width: auto;
    }
  }
}

@media screen and (max-width: 768px) {
  .characteristics-item {
    &-grid {
      width: 40%;
    }
  }
}
`}</style>
    </div>
  );
}

Characteristic.propTypes = {};

Characteristic.defaultProps = {};

export default Characteristic;
